import { findLastVisiblePageIndex } from '../../../surveyLogic/navigation/findVisiblePageIndex';
import { getNextVisiblePageIndex } from '../../../surveyLogic/navigation/getNextVisiblePageIndex';
import { trackPageSkipped } from '../../../surveyLogic/telemetry/logicTelemetry';
import { finishCurrentPage } from './finishCurrentPage';
import { markDisplayHiddenPagesSkipped } from './markSkippedPages';
import { navigateToPage } from './navigateToPage';
import type { OnNextRunState } from './types';

/** Normal forward move: next visible page, or submit on the last visible page. */
export function goToNextVisiblePageOrSubmit(run: OnNextRunState): void {
  finishCurrentPage(run);

  const nextPageIndex = getNextVisiblePageIndex(
    run.pages,
    run.currentPageIndex,
    run.logicContext
  );
  const lastVisiblePageIndex = findLastVisiblePageIndex(run.pages, run.logicContext);
  const isLastVisiblePage =
    lastVisiblePageIndex >= 0 && run.currentPageIndex >= lastVisiblePageIndex;
  const hasNoForwardPage = nextPageIndex >= run.pages.length;

  if (hasNoForwardPage || isLastVisiblePage) {
    markDisplayHiddenPagesSkipped(
      run.refs,
      run.pages,
      run.currentPageIndex,
      run.pages.length,
      run.logicContext
    );
    void run.onSubmit();
    return;
  }

  if (nextPageIndex !== run.currentPageIndex + 1) {
    markDisplayHiddenPagesSkipped(
      run.refs,
      run.pages,
      run.currentPageIndex,
      nextPageIndex,
      run.logicContext
    );
    trackPageSkipped({
      fromPageIndex: run.currentPageIndex,
      toPageIndex: nextPageIndex,
      reason: 'empty_page',
    });
  }

  run.refs.skippedPageIndices.delete(nextPageIndex);
  navigateToPage(run, nextPageIndex);
}
